<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">
    <div class="flex-0 flex flex-row items-center justify-between w-full">
        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="backToBrief()" type="button" class="btn-fab-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="">
                <div class="inline-flex gap-x-2">
                    <h3 class="text-md font-semibold text-primary">
                        Brief Enrichments Configuration
                    </h3>
                </div>
                <p class="mt-0 text-xs text-secondary">{{ brief() ? brief()!.title : 'Loading...' }}</p>
            </div>
        </div>

        <button type="button" (click)="showHelp.set(!showHelp())" class="z-10 rounded-full bg-gray-200 dark:bg-white/10 px-2 py-1 text-xs font-semibold text-gray-700 dark:text-white ring-1 ring-inset ring-gray-300 dark:ring-white/5 hover:bg-gray-300 dark:hover:bg-white/15 cursor-pointer">What is
            this?</button>
    </div>

    <!-- Main Content -->
    <div class="h-full flex-1 flex-col items-center justify-start w-full overflow-hidden">
        <div class="overflow-y-auto scrollbar-transparent space-y-4 h-full w-full">

            <!-- Help Element -->
            @if (showHelp()) {
            <div
                class="flex flex-row items-start gap-4 w-full max-w-full py-5 px-6 bg-primary/10 dark:bg-[#1a1724] border border-[rgba(156,81,182,0.35)] rounded-xl shadow-[0_0_20px_rgba(156,81,182,0.08)]">
                <div
                    class="shrink-0 w-[60px] h-[60px] flex items-center justify-center bg-linear-to-br from-[#e91e8c] to-[#9c51b6] rounded-xl">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6 text-white">
                        <path
                            d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72" />
                        <path d="m14 7 3 3" />
                        <path d="M5 6v4" />
                        <path d="M19 14v4" />
                        <path d="M10 2v2" />
                        <path d="M7 8H3" />
                        <path d="M21 16h-4" />
                        <path d="M11 3H9" />
                    </svg>
                </div>
                <div class="flex-1 min-w-0 flex flex-col gap-2">
                    <h4 class="m-0 text-lg font-bold text-gray-900 dark:text-white leading-tight">Refine Your Brief for AI Moderation</h4>
                    <p class="m-0 text-sm leading-normal text-gray-600 dark:text-[#cccccc]">
                        We've analysed your brief and extracted a set of questions that we'll use to moderate the
                        content of
                        the brief.
                        <br />
                        Use the tolerance sliders to define exactly how strict the AI should be when reviewing content.
                        <br />
                        Move from <strong class="font-bold text-[#ff6347]">Zero Tolerance</strong>
                        (strictest) to <strong class="font-bold text-[#50b848]">Most Tolerant</strong> (most lenient)
                        for each rule. This ensures the AI moderation operates within your defined parameters.
                        <br />
                        <br />
                        <strong class="font-bold text-fuchsia-500">NB:</strong> Make sure to <strong
                            class="font-bold text-fuchsia-500">Save</strong> your changes to apply the enrichments.
                    </p>
                    <div class="flex flex-wrap items-center gap-4 mt-1">
                        <span class="inline-flex items-center gap-1.5 text-[0.8125rem] text-gray-600 dark:text-[#cccccc]">
                            <span
                                class="shrink-0 w-4.5 h-4.5 rounded-full inline-flex items-center justify-center text-[0.7rem] font-bold bg-[#50b848] text-white"
                                aria-hidden="true">✓</span>
                            <!-- {{ rulesConfiguredCount() }} of {{ rulesNeedingConfig() }} rules configured -->
                            {{ rulesConfiguredCount() }} of {{ rulesTotal() }} rules configured
                        </span>
                        <span class="inline-flex items-center gap-1.5 text-[0.8125rem] text-gray-600 dark:text-[#cccccc]">
                            <span
                                class="shrink-0 w-4.5 h-4.5 rounded-full inline-flex items-center justify-center text-[0.7rem] font-bold bg-[#9c51b6] text-white"
                                aria-hidden="true">i</span>
                            Click any question to adjust tolerance
                        </span>
                    </div>
                </div>
            </div>
            }
            <!-- Help Element - END -->

            <!-- List of DO Questions -->
            @if (doQuestions() && doQuestions()!.length > 0) {
            <div class="flex flex-row items-center justify-start w-full space-x-3 p-2 hover:cursor-pointer">
                <div class="shrink-0 size-10 flex items-center justify-center rounded-md bg-emerald-500/10">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6 text-emerald-400">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                </div>

                <p class="text-sm font-semibold text-gray-900 dark:text-white">
                    Requirements (Do's)
                </p>

                <p class="text-sm text-gray-500 dark:text-gray-400">
                    ({{ doQuestions()!.length }} questions)
                </p>
            </div>

            <div class="w-full flex flex-col gap-y-2">
                @for (question of doQuestions(); track question.id) {
                <be-question-enrich [question]="question"
                    (enrichmentChange)="onQuestionEnrichmentChange(question, $event)"></be-question-enrich>
                }
            </div>
            }
            <!-- List of DO Questions - END -->

            <!-- List of DON'T Questions -->
            @if (dontQuestions() && dontQuestions()!.length > 0) {
            <div class="flex flex-row items-center justify-start w-full space-x-3 p-2 hover:cursor-pointer">
                <div class="shrink-0 size-10 flex items-center justify-center rounded-md bg-red-500/10">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6 text-red-400">
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                    </svg>
                </div>

                <p class="text-sm font-semibold text-gray-900 dark:text-white">
                    Restrictions (Don't's)
                </p>

                <p class="text-sm text-gray-500 dark:text-gray-400">
                    ({{ dontQuestions()!.length }} questions)
                </p>
            </div>

            <div class="w-full flex flex-col gap-y-2">
                @for (question of dontQuestions(); track question.id) {
                <be-question-enrich [question]="question"
                    (enrichmentChange)="onQuestionEnrichmentChange(question, $event)"></be-question-enrich>
                }
            </div>
            }
            <!-- List of DON'T Questions - END -->

            <!-- Empty state: no questions at all -->
            @if ((!doQuestions() || doQuestions()!.length === 0) && (!dontQuestions() || dontQuestions()!.length === 0)) {
            <div class="flex flex-col items-center justify-center py-8 text-center">
              <div class="flex items-center justify-center size-10 rounded-xl bg-zinc-100 dark:bg-zinc-800/40 mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-zinc-400 dark:text-zinc-500">
                  <path d="M9 11l3 3L22 4"/>
                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
                </svg>
              </div>
              <p class="text-sm font-medium text-primary">No questions added</p>
              <p class="mt-0.5 text-xs text-secondary max-w-[180px]">Add do's and don'ts to guide your creators.</p>
            </div>
            }
            <!-- Empty state: no questions - END -->

        </div>
    </div>
    <!-- Main Content -->

    <div class="shrink-0 flex flex-row items-center justify-between w-full">
        <div>LHS</div>
        <div class="shrink-0 flex flex-row items-center justify-end gap-x-2">
            <button (click)="saveBriefEnrichments()" type="button"
                class="inline-flex items-center gap-x-1.5 rounded-full bg-linear-to-br from-[#e91e8c] to-[#9c51b6] px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:cursor-pointer">
                Save Brief Enrichments
                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="-mr-0.5 size-5">
                    <path
                        d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                        clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
            </button>
        </div>
    </div>
</div>